module.exports = __webpack_public_path__ + "assets/img/shop_banner.028a9fbd.png";